import { useEffect, useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

type ItsSearchCardProps = {
  loading: boolean;
  initialIts?: string;
  onSearch: (itsNo: string) => void;
  onReset: () => void;
  compact?: boolean;
};

export default function ItsSearchCard({
  loading,
  initialIts = "",
  onSearch,
  onReset,
  compact = false,
}: ItsSearchCardProps) {
  const [value, setValue] = useState(initialIts);

  useEffect(() => {
    setValue(initialIts);
  }, [initialIts]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(value);
  };

  const handleReset = () => {
    setValue("");
    onReset();
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      {!compact ? (
        <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
          Household lookup
        </Typography>
      ) : null}
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
        Enter 8-digit ITS — includes all family members under the same HOF.
      </Typography>
      <TextField
        label="ITS number"
        value={value}
        onChange={(e) => setValue(e.target.value.replace(/\D/g, "").slice(0, 8))}
        inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 8 }}
        size="small"
        fullWidth
        sx={{ mb: 1.5 }}
      />
      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
        <Button
          type="submit"
          variant="contained"
          disabled={loading || value.length !== 8}
          startIcon={<SearchIcon />}
          sx={{ flex: 1, minWidth: 100 }}
        >
          Search
        </Button>
        <Button
          type="button"
          variant="outlined"
          color="inherit"
          disabled={loading}
          startIcon={<RestartAltIcon />}
          onClick={handleReset}
          sx={{ flex: 1, minWidth: 100 }}
        >
          Reset
        </Button>
      </Box>
    </Box>
  );
}
